import { Injectable } from '@angular/core';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { ServiceDocAttchmentContainerModel } from '../../../../../../models/aggregates/erp/rma';
import { Core2Config } from '../../shared/core2Config';
import { HttpClient } from '@angular/common/http';
import { ApiResponseModel, ApiVisa, Pagination, PagingResponseModel } from '../../shared';
import { FilesDetailsRequest } from '../../../../../../models/file-image';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ServiceDocAttchmentService extends BaseApiTemplateService<ServiceDocAttchmentContainerModel> {

  readonly url = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'svc/doc-attachments';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'svc/doc-attachments';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'svc/doc-attachments';
    this.httpClient = http;
  }

  addSvcDocAttachment(guid: string, files: File[], visa: ApiVisa,
    filesDetails?: FilesDetailsRequest) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }

    const formData: FormData = new FormData();
    files.forEach(file => formData.append('files', file));
    if (filesDetails) {
      formData.set(
        'data',
        new Blob([JSON.stringify(filesDetails)], { type: 'application/json' }),
        'data.json')
    }


    return this.httpClient.put<ApiResponseModel<any>>(
      this.apiUrl + '/add-files/backoffice-ep/' + guid,
      formData,
      this.getHttpHeader(visa)
    );
  }


  public getAttchmentByCriteria(
    pagination: Pagination,
    visa: ApiVisa,
    criteria?: any,
  ): Observable<PagingResponseModel<ServiceDocAttchmentContainerModel>> {
    // console.log('get by criteria bsae-api');
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria =
      this.apiUrl + '/backoffice-ep' + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<ServiceDocAttchmentContainerModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

  public deleteAttachmentFile(guid: string, visa: ApiVisa): Observable<ApiResponseModel<ServiceDocAttchmentContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      console.log('this.endpoint_path && visa.api_domain_url: ', visa.api_domain_url + this.endpoint_path);
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.delete<ApiResponseModel<ServiceDocAttchmentContainerModel>>(
      this.apiUrl + '/backoffice-ep/' + guid,
      this.getHttpHeader(visa)
    );
  }

  public getAttachmentFile(guid: string, apiVisa: ApiVisa): Observable<Blob> {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<Blob>(
      this.apiUrl + '/file/backoffice-ep/' + guid,
      this.getHttpHeaderBlob(apiVisa)
    );
  }

}
